import { useOasisBackend } from "../../hooks/useOasisBackend";
import Modal from "../Modal";
import { useState } from "react";

const LANGUAGES = {
    'Afrikaans': 'af',
    'Albanian': 'sq',
    'Amharic': 'am',
    'Arabic': 'ar',
    'Armenian': 'hy',
    'Azerbaijani': 'az',
    'Bengali': 'bn',
    'Bosnian': 'bs',
    'Bulgarian': 'bg',
    'Catalan': 'ca',
    'Chinese (Simplified)': 'zh',
    'Chinese (Traditional)': 'zh-TW',
    'Croatian': 'hr',
    'Czech': 'cs',
    'Danish': 'da',
    'Dari': 'fa-AF',
    'Dutch': 'nl',
    'English': 'en',
    'Estonian': 'et',
    'Farsi (Persian)': 'fa',
    'Filipino, Tagalog': 'tl',
    'Finnish': 'fi',
    'French': 'fr',
    'French (Canada)': 'fr-CA',
    'Georgian': 'ka',
    'German': 'de',
    'Greek': 'el',
    'Gujarati': 'gu',
    'Haitian Creole': 'ht',
    'Hausa': 'ha',
    'Hebrew': 'he',
    'Hindi': 'hi',
    'Hungarian': 'hu',
    'Icelandic': 'is',
    'Indonesian': 'id',
    'Irish': 'ga',
    'Italian': 'it',
    'Japanese': 'ja',
    'Kannada': 'kn',
    'Kazakh': 'kk',
    'Korean': 'ko',
    'Latvian': 'lv',
    'Lithuanian': 'lt',
    'Macedonian': 'mk',
    'Malay': 'ms',
    'Malayalam': 'ml',
    'Maltese': 'mt',
    'Marathi': 'mr',
    'Mongolian': 'mn',
    'Norwegian (Bokmål)': 'no',
    'Pashto': 'ps',
    'Polish': 'pl',
    'Portuguese (Brazil)': 'pt',
    'Portuguese (Portugal)': 'pt-PT',
    'Punjabi': 'pa',
    'Romanian': 'ro',
    'Russian': 'ru',
    'Serbian': 'sr',
    'Sinhala': 'si',
    'Slovak': 'sk',
    'Slovenian': 'sl',
    'Somali': 'so',
    'Spanish': 'es',
    'Spanish (Mexico)': 'es-MX',
    'Swahili': 'sw',
    'Swedish': 'sv',
    'Tamil': 'ta',
    'Telugu': 'te',
    'Thai': 'th',
    'Turkish': 'tr',
    'Ukrainian': 'uk',
    'Urdu': 'ur',
    'Uzbek': 'uz',
    'Vietnamese': 'vi',
    'Welsh': 'cy'
} as const;

const TranslateDatabaseButton = ({DatabaseId}: {DatabaseId: string}) => {
    const db = useOasisBackend();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState<string>('');

    const handleTranslate = async () => {
        // Dummy function for translation
        console.log(`Translating knowledge base ${DatabaseId} to ${selectedLanguage}`);
        const response = await db.endpoints.api.apiDatabaseTranslateCreate(DatabaseId,{
            target_language_code: selectedLanguage
        });
        setIsModalOpen(false);
    };

    return (
        <>
            <button 
                onClick={() => setIsModalOpen(true)}
                className="px-3 sm:px-4 py-2 sm:py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm sm:text-base transition-colors"
            >
                Translate
            </button>

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className="p-4 sm:p-6 bg-gray-800 text-white rounded-md max-w-sm sm:max-w-md mx-auto">
                    <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Select Translation Language</h2>
                    <select
                        value={selectedLanguage}
                        onChange={(e) => setSelectedLanguage(e.target.value)}
                        className="w-full p-2 sm:p-3 border rounded mb-4 bg-gray-700 text-white text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="">Select a language</option>
                        {Object.entries(LANGUAGES).map(([language, code]) => (
                            <option key={code} value={code}>
                                {language}
                            </option>
                        ))}
                    </select>
                    <div className="flex flex-col sm:flex-row justify-end gap-2">
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="px-3 sm:px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 text-sm sm:text-base transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleTranslate}
                            disabled={!selectedLanguage}
                            className="px-3 sm:px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed text-sm sm:text-base transition-colors"
                        >
                            Translate
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default TranslateDatabaseButton;
